import React from 'react';
import { Thought, ToolResultThought } from './types';
import { getComponent } from './registry';
import DefaultToolResult from './toolResults/DefaultToolResult';
import { ThoughtMarkdown } from './ThoughtMarkdown';

interface ThoughtRendererProps {
  thought: Thought;
  onDocumentClick?: (documentId: string, documentUrl?: string | null, documentName?: string) => void;
  onTemplateClick?: (templateId: string) => void;
  onToolCallClick?: (toolCallId: string) => void;
}

export const ThoughtRenderer: React.FC<ThoughtRendererProps> = ({
  thought,
  onDocumentClick,
  onTemplateClick,
  onToolCallClick
}) => {
  const Component = getComponent(thought);
  
  if (!Component) {
    switch (thought.type) {
      case 'tool_result':
        return (
          <DefaultToolResult
            thought={thought as ToolResultThought}
            onDocumentClick={onDocumentClick}
            onTemplateClick={onTemplateClick}
          />
        );
      default:
        // Convertir onDocumentClick a onViewDocument
        const onViewDocument = onDocumentClick ? (url: string, name: string) => {
          if (url) {
            onDocumentClick('', url, name);
          }
        } : undefined;
        
        return (
          <div className="p-2.5 text-[11px] text-gray-600 leading-relaxed">
            <ThoughtMarkdown
              content={thought.thought}
              fontSize="text-[11px]"
              textColor="text-gray-600"
              onViewDocument={onViewDocument}
            />
          </div>
        );
    }
  }
  
  const props: any = {
    thought,
    ...(thought.type === 'tool_result' && {
      onDocumentClick,
      onTemplateClick
    }),
    ...(thought.type === 'tool_call' && {
      onToolCallClick
    })
  };
  
  return <Component {...props} />;
};

export default ThoughtRenderer;
